import { Breadcrumb } from "antd";
import { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link } from "react-router-dom";
import { appStore, BreadcrumbItem } from "src/appStore";
import { classNames } from "src/common/classNames";
import { LangSwitcher } from "src/components/LangSwitcher";
import { BellIcon, LogoIcon } from "src/icons";
import { makeUrl } from "src/routes/makeUrl";

import { HeaderDropdown } from "../HeaderDropdown/HeaderDropdown";
import { LeftMenuButtonTrigger } from "../LeftMenu/components/LeftMenuButtonTrigger/LeftMenuButtonTrigger";
import * as styles from "./Header.module.less";

export const Header: React.FC = observer(() => (
  <div className={styles.box}>
    <div className={classNames([styles.item, styles.logoBox])}>
      <LogoIcon />
    </div>
    <div className={classNames([styles.item, styles.menuBox])}>
      <LeftMenuButtonTrigger />
    </div>
    <div className={classNames([styles.item, styles.titleBox])}>
      {Array.isArray(appStore.pageTitle) ? (
        <Breadcrumb items={appStore.pageTitle.map(makeItem)} />
      ) : (
        <div className={styles.titleText}>{appStore.pageTitle}</div>
      )}
    </div>
    <div className={styles.item}>
      <BellIcon className={styles.bellIcon} />
    </div>
    <div className={styles.item}>
      <HeaderDropdown />
    </div>
    <div className={styles.item}>
      <LangSwitcher />
    </div>
  </div>
));

const makeItem = ({
  title,
  page,
  params,
}: BreadcrumbItem): BreadcrumbItemType => {
  const result: BreadcrumbItemType = {
    title: page ? (
      <Link to={makeUrl(page, params)}>{title}</Link>
    ) : (
      <span>{title}</span>
    ),
  };
  return result;
};
